import React from 'react';
const NotifyContext = React.createContext(null);
export const NotifyProvider = NotifyContext.Provider;
export default NotifyContext;
